<template>
  <div class="content"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>
      <v-data-table
      :headers="headers"
      :items="analyzerperson"
      sort-by="userdisplayname"
      class="table-user ml-6 mr-6 mt-4 rounded-lg"
      >
      <template v-slot:top>
        <v-toolbar flat class="rounded-lg">
          <v-toolbar-title><v-icon class="mr-2">mdi-earth</v-icon>Daftar Orang terkenal</v-toolbar-title>
          <v-spacer></v-spacer>


          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined rounded small color="primary" class="mb-2" v-bind="attrs" v-on="on">
                Tambah orang baru
                <v-icon class="ml-2">mdi-plus</v-icon>
              </v-btn>
            </template>

            
            <v-card>
        
              <v-card-title>
                <v-card-title><span class="text-h6">{{ formTitle }}</span></v-card-title>
              </v-card-title>
              <v-card-text style="height: 400px;" class="overflow-card">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field outlined dense v-model="userid" label="Username Twitter" 
                      hint="Input Username Twitter without @" persistent-hint>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field outlined dense v-model="userdisplayname" label="Username Display Name" 
                      hint="Input Username Display Name" persistent-hint>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-select dense outlined item-text="name" item-value="value" v-model="usertype" :items="itemsusertype" hint="User type of famous person" persistent-hint ></v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-select dense outlined item-text="name_active" item-value="valueactive" v-model="statusactive" :items="itemsactivate"
                      hint="Activate/Disable crawling person by system" persistent-hint></v-select>
                    </v-col>
                    <v-col> 
                      <!-- <v-file-input dense outlined chips accept="image/*" multiple  type="file" ref="file" label="Include some file" hint="Upload photo"  @change="selectfile"></v-file-input> -->
                      <input dense outlined chips accept="image/*" type="file"  ref="file" @change="selectfile">
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field outlined dense label="User Profile Image URL" v-model="image_url"
                      hint="Input URL of image" persistent-hint>
                      </v-text-field>
                    </v-col>

                    <!-- <v-col cols="12" sm="12" md="12">
                      <v-text-field outlined dense label="User Alias" v-model="alias">
                      </v-text-field>
                    </v-col> -->
                    
                    <v-row class="ma-0 pa-0 ml-3 mt-2" v-for="(item, index) in item_alians" :key="index">
                      <v-flex lg8>
                        <v-text-field outlined dense v-model="item.alias" label="User Alias"></v-text-field>
                      </v-flex>
                      <v-flex lg4>
                        <v-btn class="mx-2 elevation-0" @click="add" dark outlined icon color="#0471A5"><v-icon>mdi-plus</v-icon></v-btn>
                        <v-btn class="elevation-0"  @click="remove(item, index)" outlined color="#0471A5" icon><v-icon>mdi-minus</v-icon></v-btn>
                      </v-flex>
                    </v-row>

                  </v-row>
                </v-container>
              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions class="py-3">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense @click="save">
                  Save 
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>



          <v-dialog v-model="dialogDelete" width="330px">
            <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
              <v-avatar class="color-avatar3 my-4" size="62">
                <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
              </v-avatar>
              <div class="text-center text-h6 align-center justify-center font-weight-medium">
                Confirm Deletion
              </div> 
              <v-card-text class="align-center justify-center mt-2">
                Are you sure you want to permanently delete this item?
              </v-card-text>

              <v-divider class="mt-4" style=""></v-divider>

              <v-card-actions class="align-center justify-center">
                <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="deleteItemConfirm">
                  OK
                </v-btn>
                <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
                  Cancel 
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item.SEQ_ID)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item.SEQ_ID)">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">
          Reset
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script> 
// import ProfileService from '@/services/ProfileService'
import axios from "axios"
  export default {
    data: () => ({
      page: [
        {
          text: 'Home',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Analyzer Config',
          disabled: false,
          href: 'breadcrumbs_link_1',
        },
        {
          text: 'Person',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],



      // ====================
      // variable input 
      // ====================
      id_person:'',
      userdisplayname: '',
      status: '',
      userid: '',
      alias: '',
      
      item_alians: [
        {alias : '',id_alias : ''}
      ],
      statusactive: {//selected
        valueactive: 1,
        name_active: "Active"
      },
      itemsactivate: [//choice select
        {valueactive: 1, name_active: "Active" },
        {valueactive: 0, name_active: "Disable" }
      ],
      usertype: {
          value: 0,
          name: "Twitter"
      },
      itemsusertype: [
        {value: 0, name: "Twitter" },
        {value: 1, name: "Youtube" }
      ],
      // ====================
      // end input 
      // ====================



      dialog: false,
      dialogDelete: false,
      headers: [
        { text: 'Id', value: 'SEQ_ID' },
        { text: 'User Display Name', value: 'USER_DISPLAY_NAME' },
        { text: 'Status', value: 'USER_STATUS' },
        { text: 'User ID', value: 'USER_ID' },
        { text: 'User Type', value: 'USER_TYPE' },
        { text: 'Created Date', value: 'SYS_CREATED_DATE' },
        { text: 'Created By', value: 'USER_CREATE' },
        { text: 'Update Date', value: 'SYS_UPDATED_DATE' },
        { text: 'Update By', value: 'USER_UPDATE' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      analyzerperson: [],
      editedIndex: -1,
      file: "",
      editedItem: {
        // userdisplayname: 'Agus Wibowo',
        // status: 'Active',
        // userid: 'Aguswibowo',
        // usertype: 'Twitter',
        // createddate: '2018-12-04 14:56:44',
        // createdby: 'QC',
        // updatedate: '2019-11-12 15:59:56',
        // updateby: 'QC',
      },
      defaultItem: {
        // userdisplayname: 'Agus Wibowo',
        // status: 'Active',
        // userid: 'Aguswibowo',
        // usertype: 'Twitter',
        // createddate: '2018-12-04 14:56:44',
        // createdby: 'QC',
        // updatedate: '2019-11-12 15:59:56',
        // updateby: 'QC',
      },
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Add Seed URL' : 'Edit Seed URL'
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
    },
    methods: {
      initialize () {
        
        axios.get("analyzer_person",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            this.analyzerperson = response.data[0];
            // end loading 
            setTimeout(() =>{
              this.loading = false
            },1000)
          })
          .catch((e) => {
              switch (e.response.status) {
                  case 404:
                        alert('Maaf Anda Belum Login')
                        this.$router.push('/');
                        // jika belum login local storage wajib dihapus
                        localStorage.removeItem('username');
                        localStorage.removeItem('token_app');
                        localStorage.removeItem('email');
                      break;
                  case 403:
                    
                        alert('Maaf Anda Menyalahi Wewenang Menggunakan Sistem Ini')
                        this.$router.push('/');
                        // jika belum login local storage wajib dihapus
                        localStorage.removeItem('username');
                        localStorage.removeItem('token_app');
                        localStorage.removeItem('email');
                      break;
                  default:
                      console.log('some other error');  // end up here all the time
                      break;
                  }
          this.errors=e.response.data.msg;
        });
      },
      deleteItem (item) {
        this.editedIndex = this.analyzerperson.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.analyzerperson.splice(this.editedIndex, 1)
        axios({
          method: "delete",
          url: "analyzer_person/delete",
          data: {
            seq_id: this.id_person
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          // handle success
          console.log(response.data.data);
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        this.closeDelete()
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },







      selectfile() {
        this.file = this.$refs.file.files[0];

      },

      editItem (item) {
        this.editedIndex = this.analyzerperson.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      async save () {
        // alert(this.usertype);
        // alert(this.statusactive);
        console.log(this.usertype);
        console.log(this.statusactive);
        // console.log(this.userdisplayname);
        
        const formData = new FormData();
        formData.append(
          `file`,
          this.file,
          this.file.name
        );
        // console.log(formData);
        for (var item of formData.entries()) {
            console.log(item[0]+ ', ' + item[1]); 
        }
        if (this.editedIndex > -1) {
          Object.assign(this.analyzerperson[this.editedIndex], this.editedItem)
        } else {
          this.analyzerperson.push(this.editedItem)
         await axios.post("analyzer_person/insert",formData, 
            { headers:
              {
                'auth-token':localStorage.getItem('token_app'),
                'Content-Type': 'multipart/form-data;boundary=---uuWebKitFormBoundaryg7okV37G7Gfll2hf',
              }
            },
            {
              user_id:this.userid,
              user_display_name:this.userdisplayname,
              user_status:this.statusactive,
              user_type:this.usertype,
              user_profile_img_url:this.image_url,
              // user_alias:[this.alias],
              user_alias:this.item_alians,
              
            },
            {dataType: 'json'},
            
            )
          .then((response) => {
              this.$router.push('/person');
              console.log(response.data);  
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          alert('Maaf Anda Belum Login')
                          this.$router.push('/');
                          // jika belum login local storage wajib dihapus
                          localStorage.removeItem('username');
                          localStorage.removeItem('token_app');
                          localStorage.removeItem('email');
                        break;
                    case 403:
                          alert('Maaf Anda Menyalahi Wewenang Menggunakan Sistem Ini')
                          this.$router.push('/');
                          // jika belum login local storage wajib dihapus
                          localStorage.removeItem('username');
                          localStorage.removeItem('token_app');
                          localStorage.removeItem('email');
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });
        }
        this.close()
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      
      add() {
        this.originalData = null
        this.item_alians.push({ alias: '' ,id_alias: '' })
        // this.editIndex = this.item_insert_dinamis.length - 1
      },
      remove(item, index) {
        // console.log(item.id_keyword);
        // console.log('auu'+index);
        if(item.id_alias != null){
          // axios({
          //   method: "delete",
          //   url: "/delete-keyword-topic",
          //   data: {
          //     seq_id_keyword: item.id_alias
          //   },
          //   headers:{'auth-token':localStorage.getItem('token_app')},
          //   dataType: 'json'
          // })
          // .then((response) => {
          //   // handle success
          //   this.editItemKeyword(item.id_topic_keyword);
          //   console.log(response);
          // })
          // .catch(function (error) {
          //   // handle error
          //   console.log(error);
          // })
        }
        if(index > 0){
          this.item_alians.splice(index, 1)
        }else{
          alert('Baris Pertama tidak bisa dihapus');
        }
      },
    },
  }
</script>

<style scoped>
.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
</style>